import { useTranslation } from "react-i18next";
import { MdLogin } from "react-icons/md";
import Button from "shared/components/Button";
import { NAME_SPACES } from "shared/locales/constants";

const ZitadelButton = ({ onZitadelLogin }) => {
  const { t: auth } = useTranslation(NAME_SPACES.AUTH);
  const SIGN_IN = auth("SIGN_IN", {
    returnObjects: true,
  });
  return (
    <div className="auth__body">
      <Button type="primary" onClick={onZitadelLogin}>
        {SIGN_IN.ZITADEL}
        <MdLogin size={16} />
      </Button>
    </div>
  );
};

export default ZitadelButton;
